/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Cookies_DescriptionInputs */

const en_legal_cookies_description = /** @type {(inputs: Legal_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cookies we use and how to control them.`)
};

const pl_legal_cookies_description = /** @type {(inputs: Legal_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jakich plików cookie używamy i jak możesz nimi zarządzać.`)
};

/**
* | output |
* | --- |
* | "The cookies we use and how to control them." |
*
* @param {Legal_Cookies_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_cookies_description = /** @type {((inputs?: Legal_Cookies_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Cookies_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_cookies_description(inputs)
	return en_legal_cookies_description(inputs)
});